/**
 * Created by pajicv on 9/29/18.
 */
import { functions, auth, app } from './firebase';
import axios from 'axios';

const sendEmail = ({ from, to, subject, html }) => {
    console.log('Invite send');
    /*const httpEmail = functions.httpsCallable('httpEmail');
    return httpEmail({ from, to, subject, html });*/

    return auth.currentUser.getIdToken()
        .then(token => {
            return axios({
                url: `https://uxs-backend.tk/sendMail`,
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                data: { data: { from, to, subject, html } }
            })
                .then(console.log)
                .catch(console.log)
        });
};

const downloadDoc = (fileName, filePath) => {
    console.log('Download start...',fileName, filePath);
    return auth.currentUser.getIdToken()
        .then(token => {
            return axios({
                url: `https://uxs-backend.tk`,
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                responseType: 'blob',
                data: { fileName, filePath, storage: app.options.storageBucket },
            })
        });
    // const downloadDocument = functions.httpsCallable('downloadDocument');
    // return downloadDocument({ fileName, filePath });
};
const getSignedUrl = (fileName, filePath) => {
    const getSignedUrl = functions.httpsCallable('getSignedUrl');
    return getSignedUrl({ fileName, filePath });
};

export { sendEmail, downloadDoc, getSignedUrl };



// WEBPACK FOOTER //
// ./src/firebase/functions.js